/**
 * Severity tiers for Work Queue events, mirroring the aims-htl V1 prototype.
 *
 * The left card bar is coral for the two urgent tiers (act_now, critical) and
 * neutral otherwise, per the meeting-agreed design. Quick-filter chips are
 * exposed for act_now / critical / heads_up (see QUICK_FILTER_SEVERITIES).
 */
export const SEVERITY = {
  ACT_NOW: 'act_now',
  CRITICAL: 'critical',
  ACTION: 'action',
  HEADS_UP: 'heads_up',
};

export const SEVERITY_META = {
  [SEVERITY.ACT_NOW]: {
    id: SEVERITY.ACT_NOW,
    labelKey: 'severity.actNow',
    tone: 'coral',
    dotClassName: 'bg-rose-500',
    barClassName: 'bg-rose-500',
    chipClassName: 'bg-rose-500/15 text-rose-500',
    chipBorderClassName: '!border-rose-500 focus-visible:!border-rose-400',
    chipSelectedClassName:
      '!border-rose-500 !bg-rose-500 hover:!bg-rose-600 focus-visible:!border-rose-300 dark:!bg-rose-500 dark:hover:!bg-rose-600',
  },
  [SEVERITY.CRITICAL]: {
    id: SEVERITY.CRITICAL,
    labelKey: 'severity.critical',
    tone: 'coral',
    dotClassName: 'bg-rose-500',
    barClassName: 'bg-rose-500',
    chipClassName: 'bg-rose-500/15 text-rose-500',
    chipBorderClassName: '!border-rose-500 focus-visible:!border-rose-400',
    chipSelectedClassName:
      '!border-rose-500 !bg-rose-500 hover:!bg-rose-600 focus-visible:!border-rose-300 dark:!bg-rose-500 dark:hover:!bg-rose-600',
  },
  [SEVERITY.ACTION]: {
    id: SEVERITY.ACTION,
    labelKey: 'severity.action',
    tone: 'neutral',
    dotClassName: 'bg-sky-500',
    barClassName: 'bg-edge-strong',
    chipClassName: 'bg-sky-500/15 text-sky-500',
    chipBorderClassName: '!border-sky-500 focus-visible:!border-sky-400',
    chipSelectedClassName:
      '!border-sky-500 !bg-sky-500 hover:!bg-sky-600 focus-visible:!border-sky-300 dark:!bg-sky-500 dark:hover:!bg-sky-600',
  },
  [SEVERITY.HEADS_UP]: {
    id: SEVERITY.HEADS_UP,
    labelKey: 'severity.headsUp',
    tone: 'neutral',
    dotClassName: 'bg-emerald-500',
    barClassName: 'bg-edge-strong',
    chipClassName: 'bg-emerald-500/15 text-emerald-500',
    chipBorderClassName: '!border-emerald-500 focus-visible:!border-emerald-400',
    chipSelectedClassName:
      '!border-emerald-500 !bg-emerald-500 hover:!bg-emerald-600 focus-visible:!border-emerald-300 dark:!bg-emerald-500 dark:hover:!bg-emerald-600',
  },
};

/**
 * Risk framing shown when handing an event to someone else (Escalate). Derived
 * from severity so there is a single source of urgency until the backend ships
 * an explicit risk score.
 */
export const SEVERITY_RISK = {
  [SEVERITY.ACT_NOW]: { labelKey: 'escalate.riskHigh', className: 'text-rose-500' },
  [SEVERITY.CRITICAL]: { labelKey: 'escalate.riskHigh', className: 'text-rose-500' },
  [SEVERITY.ACTION]: { labelKey: 'escalate.riskMedium', className: 'text-amber-500' },
  [SEVERITY.HEADS_UP]: { labelKey: 'escalate.riskLow', className: 'text-emerald-500' },
};

/** Rank used to sort the list by severity descending (act_now first). */
export const SEVERITY_RANK = {
  [SEVERITY.ACT_NOW]: 0,
  [SEVERITY.CRITICAL]: 1,
  [SEVERITY.ACTION]: 2,
  [SEVERITY.HEADS_UP]: 3,
};

/** Severities surfaced as quick-filter chips above the list. */
export const QUICK_FILTER_SEVERITIES = [SEVERITY.ACT_NOW, SEVERITY.CRITICAL, SEVERITY.HEADS_UP];
